'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var WaterHeater = function (_React$Component) {
    _inherits(WaterHeater, _React$Component);

    function WaterHeater() {
        _classCallCheck(this, WaterHeater);

        return _possibleConstructorReturn(this, (WaterHeater.__proto__ || Object.getPrototypeOf(WaterHeater)).apply(this, arguments));
    }

    _createClass(WaterHeater, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M3.96 5.803c-.106-2.61 1.065-4.03 2.774-4.81 1.652-.756 3.794-.89 5.742-.94 2.02-.053 4.26.03 6.017.79 1.812.78 3.106 2.256 3.138 4.976l.056 22.205c.002.082.007.175.012.257.028.497.04.72-.416.863-.292.09-1.582.293-2.75.475-.842.132-1.62.253-1.825.287-.326.673-.937 1.206-1.687 1.563-.62.294-1.34.47-2.068.5-.73.03-1.473-.083-2.142-.364-.787-.332-1.47-.894-1.905-1.725-.28-.044-.657-.088-1.077-.137-1.24-.145-2.825-.33-3.558-.748-.318-.18-.315-.475-.31-.788V5.805zm3.02-4.27c-1.495.684-2.52 1.935-2.425 4.247v22.432c-.002.133-.004.257.01.265.626.356 2.145.534 3.332.673.504.06.95.112 1.263.17l.15.03.064.136c.363.764.966 1.275 1.668 1.572.585.246 1.24.345 1.888.318s1.287-.183 1.838-.444c.67-.318 1.2-.79 1.448-1.378l.035-.084.076-.05c.11-.073 1.065-.222 2.117-.386 1.142-.178 2.405-.375 2.664-.457.013-.004.01-.084 0-.26-.006-.075-.01-.16-.013-.277L21.04 5.827c-.03-2.43-1.176-3.744-2.78-4.436C16.6.676 14.442.598 12.49.65c-1.885.048-3.956.175-5.508.885z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M8.77 29.246c1.174.146 2.472.224 3.853.227 1.34.003 2.767-.063 4.24-.207l.056.59c-1.492.146-2.936.214-4.298.21-1.417-.004-2.738-.083-3.924-.23l.072-.59zM12.83 6.2c.848 0 1.616.343 2.17.898s.9 1.323.9 2.17-.344 1.615-.9 2.17c-.554.555-1.322.9-2.17.9s-1.613-.345-2.17-.9c-.554-.555-.898-1.323-.898-2.17s.344-1.614.9-2.17c.555-.555 1.322-.9 2.17-.9zm1.75 1.32c-.447-.448-1.066-.725-1.75-.725s-1.3.277-1.748.724c-.447.447-.724 1.065-.724 1.748s.277 1.3.724 1.75c.448.446 1.066.723 1.75.723s1.3-.276 1.748-.723c.447-.447.724-1.066.724-1.75s-.277-1.3-.724-1.748z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M12.64 9.495l-1.273-1.41c-.074-.095-.004-.163.098-.12l1.557 1.074c.465.313-.037.812-.382.455zM12.09 10.48h1.48v.358h-1.48v-.358zM11.69 7.72c.897-.877 2.913-.424 3.05 1.353l-.63.006c-.066-1.148-1.147-1.76-2.296-1.273l-.124-.086z' })
            );
        }
    }]);

    return WaterHeater;
}(_react2.default.Component);

WaterHeater.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = WaterHeater;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/water-heater.js
// module id = 1134
// module chunks = 0